<template lang="pug">
ValidationObserver(v-slot="{ handleSubmit, invalid }")
  form(@submit.prevent="handleSubmit(submit)")
    .l-content
      .l-container
        .c-container
          .u-ptxl
            span.u-anim-slideup お送りした4桁の認証番号を入力してください

      .l-container
        .c-container.is-form
          .c-cells-table
            .c-cells-table-cell__input
              ValidationProvider(rules="required|length:4")
                input(
                  type="number"
                  name="tel"
                  v-model="code"
                  autofocus)
            .c-cells-table-cell__input
              .flex-item(
                :class="{ 'active': activeDigit === 0 }")
              .flex-item(
                :class="{ 'active': activeDigit === 1 }")
              .flex-item(
                :class="{ 'active': activeDigit === 2 }")
              .flex-item(
                :class="{ 'active': activeDigit === 3 }")

      .l-container
        .c-container
          .u-color-gray 複数回以上処理を行った場合はロックがかかります。
          .u-color-gray 認証番号が届かない場合は時間をあけてお試しください。

      .l-container
        .c-container.worker_is_check
          .c-cells-table
            .c-cells-table-cell
              .c-cells-table__value
                a(href="https://plus.gigbase.jp/talent/talent-help/3469/#phone" target="_blank") 認証番号が届かない場合はこちら

      .l-container.is-bottom
        .u-mvm.u-text-center
          .c-button-floating-action-group
            button.c-button-float-lg.c-button.c-button--block.c-button--secondary(slot="right", type="submit", :disabled="invalid")
              i.material-icons keyboard_arrow_right
</template>

<script lang="babel">
  import ApiAlertMixin from "@/mixins/ApiAlertMixin";
  import {computed, defineComponent, onMounted} from "vue";
  import {ref, inject} from "vue";
  import {SIGNUP_STORE} from "@/constants/InjectionKeys";
  import {useRouter} from "vue-router/composables";
  import PhoneNumberAuthorization from "@/api/phone_number_authorization";
  import {useAlert} from "@/composables/useAlert";
  import {ValidationObserver, ValidationProvider} from "vee-validate";

  export default defineComponent({
    name: 'VerifyPhoneNumberAuthorization',
    mixins: [ ApiAlertMixin ],
    components: { ValidationObserver, ValidationProvider },
    setup(_, { emit }) {
      emit('page-navbar', true);

      const router = useRouter()
      const code = ref('')
      const activeDigit = computed(() => code.value.length)

      const { worker, setWorker } = inject(SIGNUP_STORE)
      const { showErrorAlert } = useAlert()

      const submit = () => {
        emit('loading', true);

        PhoneNumberAuthorization.certification({ authorization_code: code.value, tel: worker.tel })
          .then((response) => {
            const payload = response.data.payload;
            setWorker({ phone_number_authorization: { token: payload.token } });

            router.replace({ name: "profile" });
          })
          .catch(showErrorAlert)
          .finally(() => {
            emit('loading', false)
          });
      }

      return { code, activeDigit, submit }
    },
    watch: {
      code(newVal, oldVal) {
        if ( newVal.length > 4 ) {
          this.code = oldVal
        } else if ( newVal.length == 4 ) {
          const blurInput = () => {
            const e = document.activeElement
            e.blur()
          }
          setTimeout(blurInput, 100)
        }
      }
    },
  })
</script>

<style lang="scss" scoped>
  .l-header {
    .c-navbar {
      background: white !important;
      box-shadow: none !important;
    }
    .c-button {
      margin-top: 10px;
    }
    .material-icons {
      font-size: 40px;
      color: #F94848;
    }
  }
  .c-container {
    span {
      font-size: 18px;
      line-height: 18px;
      letter-spacing: 0.03em;
    }
    .c-cells-table-cell {
      padding: 0;
      box-shadow: none;
      .c-cells-table-cell__action{
        padding: 0;
      }
      .c-cells-table-cell__action.is-check {
        .material-icons {
          background: #FFFFFF;
          border: 1px solid #E5E5E5;
          box-sizing: border-box;
          border-radius: 6px;
          border-radius: 5px;
        }
        &.success {
          .material-icons {
            color: #F94848;
          }
        }
      }
    }
    .c-cells-table__title {
      color: #222222;
      padding: {
        right: 0;
        left: 0;
      }
    }
    .c-cells-table-cell__input {
      /* width: 65%; */
      width: 200px;
      margin-left: 0;
      input[type="number"] {
        padding: 10px 10px 10px 20px;
        letter-spacing: 40px;
      }
      &:last-child {
        display: flex;
        .flex-item {
          flex: 1;
          width: 40px;  /* (200 / 4) - 5*2 */
          margin: 0 5px;
          box-sizing: content-box;
          border-top: 1px solid rgba(0, 0, 0, 0.1);;
        }
        .flex-item.active {
          border-top: 2px solid #F94848;
        }
      }
    }
  }
  .l-container.is-bottom {
    .c-button-float-lg {
      position: fixed;
      bottom: 24px;
      right: 16px;
      color: white;
      background-color: #F94848;
      box-shadow: 0 5px 12px rgba(111, 0, 24, 0.2);
      .material-icons {
        vertical-align: initial;
      }
    }
    .c-button-floating-action-group {
      button:disabled {
        background: #E0E0E0;
      }
    }
  }
</style>
